// Empty shim module used to satisfy optional imports during bundling
export const fromHex = (v) => v;
export const getAddress = (v) => v;
export const toHex = (v) => v;
export const createSiweMessage = () => '';
export default {};
